// Generated by CoffeeScript 1.9.2
module.exports = [
  // require('./ops/boolean'),
  // require('./ops/conditional'),
  // require('./ops/maths'),
  require('./ops/transform'),
  // require('./ops/fill'),
  // require('./ops/filter'),
  // require('./ops/strings'),
  // require('./ops/assign'),
  // require('./ops/types'),
  // require('./ops/json')
]
